import { render, staticRenderFns } from "./TicketPriceList.vue?vue&type=template&id=197279b2"
import script from "./TicketPriceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketPriceList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TicketPriceList.vue?vue&type=style&index=0&id=197279b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports